import { HeadingLevel } from '../types/common';

/**
 * Helper function to calculate child heading level
 * Ensures the result is always a valid heading level (1-6)
 * @param parentLevel - The parent component's heading level
 * @returns The appropriate child heading level (parentLevel + 1, capped at 6)
 */
export const getChildHeadingLevel = (parentLevel: HeadingLevel): HeadingLevel => {
  return Math.min(parentLevel + 1, 6) as HeadingLevel;
};
